module.exports = __webpack_public_path__ + "img/background_c3-1-1_mobile.9b1a6c99.png";